"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SymbolFlags = void 0;
class SymbolFlags {
    constructor(obj) {
        // Take in an object, and assign every property from that
        // object onto this newly created object.
        for (const prop in obj) {
            this[prop] = obj[prop];
        }
    }
}
exports.SymbolFlags = SymbolFlags;
//# sourceMappingURL=SymbolFlags.js.map